import React, { FunctionComponent, useContext } from 'react';
import styled from 'styled-components';
import { BrandStore, RegistrationStore } from '../../context';
import { history } from '../../history';
import { Button } from '../index';
import { registrationIsConditionalApproved } from '../../util/registration.util';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 15%;

  > h2 p {
    text-align: center;
    flex: 0 0 50%;
  }

  > div {
    display: flex;
    justify-content: center;

    > span {
      text-align: center;
      flex: 0 0 60%;
    }
  }
`;

export const SubmissionCompleteContainer: FunctionComponent = props => {
  const {
    state: { brand },
  } = useContext(BrandStore);

  const {
    state: { registration },
  } = useContext(RegistrationStore);

  /* Default output elements */
  let { regSubmissionHeader, regSubmissionBody } = brand || {};

  let allDoneButton = (
    <Button
      variant="link"
      type="button"
      id="pizza-tracker-success-button"
      data-testid="pizza-tracker-success-button"
      onClick={() => history.push('/application/review')}
    >
      <span>Modify Application</span>
    </Button>
  );

  /* When conditionally approved */
  if (registrationIsConditionalApproved(registration)) {
    const redirectUrl = process.env.REACT_APP_OMNI_APP_URL ?? '';
    regSubmissionHeader = 'Documents were successfully uploaded';
    regSubmissionBody =
      'It may take up to 24 hours for your documents to be reviewed after upload.';
    allDoneButton = (
      <Button
        id="pizza-tracker-success-button-conditionalapproved"
        data-testid="pizza-tracker-success-button-conditionalapproved"
        motif="tertiary"
        onClick={() => (window.location.href = redirectUrl + '/#/dashboard')}
      >
        <span>Return to Dashboard</span>
      </Button>
    );
  }
  return (
    <Container
      id="submission-complete-container"
      data-testid="submission-complete-container"
    >
      <h2>{regSubmissionHeader}</h2>
      <div>
        <span>{regSubmissionBody}</span>
      </div>
      <p>{allDoneButton}</p>
    </Container>
  );
};
